var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { CaptionStylesRem } from './CaptionStyles';
export var Caption = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"
    // * ToDo Update to a p tag + fix style discrepancies
])), CaptionStylesRem('caption'));
// * ToDo Update to a p tag + fix style discrepancies
export var CaptionLarge = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CaptionStylesRem('captionLarge'));
var templateObject_1, templateObject_2;
